export const uSwitchFooterStyles = {
  backgroundColor: "#F3F3F4",
};
